import React, {useEffect} from 'react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import * as advanceDiagnosticIconTypes from '@/consts/advanceDiagnostic/advanceDiagnosticIconTypes';
import {ADVANCED_DIAGNOSTICS_CONSUMABLES_SOLVED_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import SupportAndStoreTemplate from '@/containers/AdvancedDiagnosticPage/components/SupportAndStoreTemplate';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appRouterService from '@/services/route/appRouterService';

import AdvancedDiagnosticDescription from '../components/AdvancedDiagnosticDescription';
import AdvancedDiagnosticIcon from '../components/AdvancedDiagnosticIcon';
import AdvancedDiagnosticLayout from '../components/AdvancedDiagnosticLayout';
import AdvancedDiagnosticTitle from '../components/AdvancedDiagnosticTitle';

const BackButton = ({className, light}) => (
    <AppButton
        primary
        light={light}
        onClick={appRouterService.forwardToDevicesPage}
        className={className}
        aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CONSUMABLES_SOLVED_BUTTON_ARIA_LABEL)}
    >
        <AemComponent
            component={EditableText}
            pageName={routePaths.ADVANCE_DIAGNOSTIC}
            itemName='consumablessolvedbutton'
        />
    </AppButton>
);

const AdvancedDiagnosticFittingConsumablesSolved = () => {
    const isDesktop = useIsDesktopLayout();

    useEffect(() => {
        amplitudeADTracking.trackADInitialQuestionnaireScreen();
        googleAnalyticsService.trackAdInitialQuestionnaireScreenView();
    }, []);

    return (
        <AdvancedDiagnosticLayout>
            <AdvancedDiagnosticLayout.ContentWrapper>
                <AdvancedDiagnosticLayout.Container sectionClassName='justify-between'>
                    <div />
                    <div className='flex flex-col items-center justify-center'>
                        <AdvancedDiagnosticIcon className='h-12 w-12' type={advanceDiagnosticIconTypes.SUCCESS} />
                        <div className='px-8'>
                            <AdvancedDiagnosticTitle itemName='consumablessolvedtitle' />
                            <AdvancedDiagnosticDescription itemName='consumablessolveddesc' />
                        </div>
                    </div>
                    <div className='w-full'>
                        {isDesktop && <BackButton light className='m-auto mt-8 w-full' />}

                        <SupportAndStoreTemplate className='mb-4 flex-col ml:mt-4 ml:flex-row' />

                        {!isDesktop && <BackButton className='m-auto w-full md:w-auto ml:w-full' />}
                    </div>
                </AdvancedDiagnosticLayout.Container>
            </AdvancedDiagnosticLayout.ContentWrapper>
        </AdvancedDiagnosticLayout>
    );
};

export default AdvancedDiagnosticFittingConsumablesSolved;
